import { Datagrid, TextField, ShowButton, EditButton } from "react-admin";
import {
  DateField,
  DeleteButton,
  CreateOnlyTopToolbar,
  CustomList,
} from "../../shared/components/index.js";

const listTags = () => (
  <CustomList actions={<CreateOnlyTopToolbar />}>
    <Datagrid rowClick={false} bulkActionButtons={false}>
      <TextField source="name" />
      <DateField source="created_at" />
      <DateField source="updated_at" />
      <ShowButton className="button-show" />
      <EditButton className="button-edit" />
      <DeleteButton className="button-delete" />
    </Datagrid>
  </CustomList>
);

export default listTags;
